import { SizeType } from '@config/type'
import cn from 'classnames'
import { AddressModel } from '@entities/address/model/domain/address.model'
import { GroupBase, MenuListProps } from 'react-select'

import { AddressSearchItemMobile } from '../address-item-mobile'

import styles from './address-list-mobile.module.css'

export const AddressSelectListMobile = ({
  options,
  selectOption,
  selectProps,
  sizeType = 'md',
  fontType = 'lg',
  styleType = 'primary',
  borderType = 'none'
}: MenuListProps<unknown, boolean, GroupBase<unknown>> & {
  sizeType?: SizeType
  fontType?: SizeType
  styleType?: 'primary' | 'secondary' | 'inverse' | 'transparent' | 'danger'
  borderType?: 'primary' | 'secondary' | 'none' | 'danger' | 'inverse'
}): JSX.Element => {
  const handleOptionClick = (option: AddressModel): void => {
    selectOption(option)
    selectProps.onMenuClose()
  }
  return (
    <div
      className={cn(styles.container, {
        [styles.primary]: styleType === 'primary',
        [styles.secondary]: styleType === 'secondary',
        [styles.transparent]: styleType === 'transparent',
        [styles.inverse]: styleType === 'inverse',
        [styles.borderNone]: borderType === 'none',
        [styles.borderPrimary]: borderType === 'primary',
        [styles.borderSecondary]:
          borderType === 'secondary' && styleType !== 'primary',
        [styles.borderInverse]:
          borderType === 'inverse' && styleType !== 'primary',
        [styles.borderDanger]:
          borderType === 'danger' || styleType === 'danger',
        [styles.danger]: styleType === 'danger'
      })}
    >
      <div className={styles.list}>
        {/* @ts-ignore */}
        {options.map((option: AddressModel) => (
          <AddressSearchItemMobile
            key={option.getAddress()}
            address={option.getAddress()}
            count={option.getUserCount()}
            onClick={() => handleOptionClick(option)}
            sizeType={sizeType}
            fontType={fontType}
            styleType={styleType}
          />
        ))}
      </div>
    </div>
  )
}
